export const formatPrice = (price?: number | null) => {
    if (price === null || price === undefined) return null;
    return price.toLocaleString('ru') + ' ₽';
};
